export const SPACING_UNIT = 4
export const spacing = (spacing: number = 1) => {
  return `${SPACING_UNIT * spacing}px`
}
